import Divider from 'components/Content/Divider/Divider';

export default Divider;
